module.exports = __webpack_public_path__ + "static/media/cancel_grey.7dd35fcc.svg";